import SearchHead from "components/searchHead";
import { SEARCH_FORM_ID_ROOM_HISTORY } from "components/constent";
import { useTranslation } from "react-i18next";
import SearchForm from "./searchForm";
import HistoryList from "./list";
import {
  ProductHistoryFilterProvider,
  ProductHistoryParamsProvider,
} from "./context";

export default function RoomHistoryPage() {
  const { t } = useTranslation();

  return (
    <>
      <SearchHead
        title={t("sub_ttl_resv")}
        formId={SEARCH_FORM_ID_ROOM_HISTORY}
        onClick={() => {}}
      />
      <ProductHistoryParamsProvider>
        <ProductHistoryFilterProvider>
          <SearchForm />
        </ProductHistoryFilterProvider>
        <HistoryList />
      </ProductHistoryParamsProvider>
    </>
  );
}
